<base-modal-component class="base-modal" [validation]="isValid()" (onConfirm)="save()">
    <fields-list-component [fields]="fields" [value]="value" name="testers_edit"></fields-list-component>
</base-modal-component>
